import useCalculateSolarProposalPricing from "~/api/hooks/useCalculateSolarProposalPricing"

import { solarPricingErrorMessage } from "./solar-pricing-error"
import { RefreshPricingAction } from "../ProposalPresentation/pricing/refresh-pricing-action"
import type { FinancingRefreshPricingProps } from "../ProposalSetup/financing/financing-kind-bundle"

/** Refresh Pricing inline beside a Credit Human refusal; refreshing writes the Quote. */
export const SolarRefreshPricingFix = ({
  proposalId,
  onRefreshed,
}: FinancingRefreshPricingProps): JSX.Element => {
  const refreshPricing = useCalculateSolarProposalPricing()
  return (
    <RefreshPricingAction
      mutation={refreshPricing}
      variables={{ proposalId }}
      canEdit
      describeError={solarPricingErrorMessage}
      onRefreshed={onRefreshed}
    />
  )
}
